<template>
  <div>
    <Header v-if="visible" />
    <sideNav v-if="visible" />
    <transition name="moveInUp">
      <router-view />
    </transition>
    <Footer v-if="visible" />
  </div>
</template>

<script>
import Header from "./components/partials/Header.vue";
import SideNav from "./components/partials/SideNav.vue";
import Footer from "./components/partials/Footer.vue";

export default {
  name: "app",
  components: {
    Header,
    SideNav,
    Footer
  },
  mounted() {
    if (this.$router.currentRoute.path == "/login") {
      this.visible = false;
    }
  },
  data() {
    return {
      visible: true
    };
  }
};
</script>

<style>
  
</style>
